import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class AudioService {
	readonly audioDictionary = {
		'likut-warehouse-scan-success': '/assets/audio/likut_ar_success.mp3',
		'likut-warehouse-scan-failure': '/assets/audio/likut_ar_failure.mp3',
		'likut-warehouse-action-success': '/assets/audio/likut_ar_action_success.mp3',
	} as const;

	audioPlaying$ = new BehaviorSubject(false);
	audioElement: HTMLAudioElement = new Audio();

	constructor() {}

	playAudio(key: keyof typeof this.audioDictionary) {
		if (this.audioPlaying$.value) {
			this.audioElement.pause();
		}
		const audio = this.audioElement;
		audio.src = this.audioDictionary[key];
		audio.play();
		this.audioPlaying$.next(true);
	}
}
